import { render, staticRenderFns } from "./awardsList.vue?vue&type=template&id=7d4030ba"
import script from "./awardsList.vue?vue&type=script&lang=js"
export * from "./awardsList.vue?vue&type=script&lang=js"
import style0 from "./awardsList.vue?vue&type=style&index=0&id=7d4030ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports